import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { OrderLocation } from "../../orders.types";

export const requestGetOrdersLocations = async (): Promise<OrderLocation[]> => {
  return await instance.get(buildUrl(ApiRoutesOrders.AllOrdersLocations), {
    params: { onlyActive: false }
  });
};
